import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store';
import VueCookies from 'vue-cookies';
import NovartisPlugin from './plugins/NovartisPlugin';
import VueGtag from "vue-gtag";
import "core-js/stable";

// Debug mode for analytics is available through the "Google Analytics Debugger" Chrome extension: https://chrome.google.com/webstore/detail/google-analytics-debugger/

Vue.config.productionTip = false

Vue.prototype.$store = store;

Vue.use(NovartisPlugin);
Vue.use(VueCookies);

let uids = {
  dev: "UA-100596251-33",
  prod: "UA-100596251-34"
}

const currUID = process.env.NODE_ENV === 'development' ? uids.dev: uids.prod

Vue.use(VueGtag, {
  config: { 
    id: currUID,
    params: {
      send_page_view: false
    } 
  }
});

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
